import { AppConfig } from "@/types/app";
import {
    MonitorPlay,
    RadioTower,
    TvMinimalPlay,
    Film,
    Wand2,
    BadgeDollarSign,
    ChartColumnBig,
    Presentation,
    ChartPie,
    ServerCog,
    BrainCircuit,
    Receipt,
    Code2,
    Archive,
    Globe,
    Sparkles
} from "lucide-react";

const getDomainFromUrl = (url: string | undefined): string => {
    if (!url) return "";
    return url.replace(/^https?:\/\//, "");
};

export const apps: AppConfig[] = [
    {
        name: "OTT CMS",
        label: getDomainFromUrl(import.meta.env.VITE_APP_OTT_CMS_URL),
        description: "Manage on-demand content",
        icon: MonitorPlay,
        color: "bg-blue-500/10 text-blue-500",
        hoverColor: "group-hover:bg-blue-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_OTT_CMS_URL,
        permissionModules: ["cms"],
        category: "content",
    },
    {
        name: "Live CMS",
        label: getDomainFromUrl(import.meta.env.VITE_APP_LIVE_CMS_URL),
        description: "Control live streaming",
        icon: RadioTower,
        color: "bg-red-500/10 text-red-500",
        hoverColor: "group-hover:bg-red-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_LIVE_CMS_URL,
        permissionModules: ["live"],
        category: "content",
    },
    {
        name: "OLD SLIKE CMS",
        label: getDomainFromUrl(import.meta.env.VITE_APP_LEGACY_CMS_URL),
        description: "Manage on-demand content",
        icon: Archive,
        color: "bg-amber-500/10 text-amber-500",
        hoverColor: "group-hover:bg-amber-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_LEGACY_CMS_URL,
        permissionModules: ["cms"],
        category: "content",
    },
    {
        name: "Chopper",
        label: getDomainFromUrl(import.meta.env.VITE_APP_CHOPPER_URL),
        description: "Highlights & Reels",
        icon: Film,
        color: "bg-purple-500/10 text-purple-500",
        hoverColor: "group-hover:bg-purple-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_CHOPPER_URL,
        permissionModules: ["cms"],
        category: "tools",
    },
    {
        name: "Optimus",
        label: getDomainFromUrl(import.meta.env.VITE_APP_OPTIMUS_URL),
        description: "AI assisted videos",
        icon: Wand2,
        color: "bg-yellow-500/10 text-yellow-500",
        hoverColor: "group-hover:bg-yellow-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_OPTIMUS_URL,
        permissionModules: ["cms"],
        category: "tools",
    },
    {
        name: "Ad Manager",
        label: getDomainFromUrl(import.meta.env.VITE_APP_AD_MANAGER_URL),
        description: "Manage advertisements",
        icon: BadgeDollarSign,
        color: "bg-indigo-500/10 text-indigo-500",
        hoverColor: "group-hover:bg-indigo-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_AD_MANAGER_URL,
        permissionModules: ["ad_manager"],
        category: "tools",
    },
    {
        name: "Analytics",
        label: getDomainFromUrl(import.meta.env.VITE_APP_ANALYTICS_URL),
        description: "Data insights & metrics",
        icon: ChartColumnBig,
        color: "bg-green-500/10 text-green-500",
        hoverColor: "group-hover:bg-green-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_ANALYTICS_URL,
        permissionModules: ["analytics"],
        category: "analytics",
    },
    {
        name: "Analytics MCP",
        label: getDomainFromUrl(import.meta.env.VITE_APP_VIDEO_ANALYTICS_MCP_URL),
        description: "Video analytics for Claude (MCP)",
        icon: Sparkles,
        color: "bg-green-500/10 text-green-500",
        hoverColor: "group-hover:bg-green-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_VIDEO_ANALYTICS_MCP_URL,
        permissionModules: ["analytics"],
        hidden: true,
        category: "analytics",
    },
    {
        name: "Content Production",
        label: getDomainFromUrl(import.meta.env.VITE_APP_CONTENT_PRODUCTION_URL),
        description: "Content Production analytics",
        icon: Presentation,
        color: "bg-pink-500/10 text-pink-500",
        hoverColor: "group-hover:bg-pink-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_CONTENT_PRODUCTION_URL,
        permissionModules: ["cms"],
        category: "analytics",
    },
    {
        name: "Looker Studio",
        label: "lookerstudio.google.com",
        description: "Looker Studio reports",
        icon: ChartPie,
        color: "bg-sky-500/10 text-sky-500",
        hoverColor: "group-hover:bg-sky-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_LOOKER_STUDIO_URL,
        permissionModules: ["cms"],
        category: "analytics",
    },
    {
        name: "Admin Console",
        label: getDomainFromUrl(import.meta.env.VITE_APP_ADMIN_CONSOLE_URL),
        description: "configure & manage account",
        icon: ServerCog,
        color: "bg-slate-500/10 text-slate-500",
        hoverColor: "group-hover:bg-slate-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_ADMIN_CONSOLE_URL,
        permissionModules: ["admin_console"],
        category: "admin",
    },
    {
        name: "Compass AI",
        label: getDomainFromUrl(import.meta.env.VITE_APP_COMPASS_AI_URL),
        description: "AI Driven Project Management",
        icon: BrainCircuit,
        color: "bg-violet-500/10 text-violet-500",
        hoverColor: "group-hover:bg-violet-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_COMPASS_AI_URL,
        permissionModules: ["compass"],
        category: "admin",
    },
    {
        name: "Billing Dashboard",
        label: getDomainFromUrl(import.meta.env.VITE_APP_BILLING_URL),
        description: "Manage billing & invoices",
        icon: Receipt,
        color: "bg-emerald-500/10 text-emerald-500",
        hoverColor: "group-hover:bg-emerald-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_BILLING_URL,
        permissionModules: ["billing"],
        category: "admin",
    },
    {
        name: "Developer Console",
        label: getDomainFromUrl(import.meta.env.VITE_APP_DEVELOPER_CONSOLE_URL),
        description: "API & integrations",
        icon: Code2,
        color: "bg-cyan-500/10 text-cyan-500",
        hoverColor: "group-hover:bg-cyan-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_DEVELOPER_CONSOLE_URL,
        alwaysAccessible: true,
        permissionModules: undefined,
        category: "other",
    },
    {
        name: "Brand Site",
        label: getDomainFromUrl(import.meta.env.VITE_APP_BRAND_SITE_URL),
        description: "Slike Marketing Website",
        icon: Globe,
        color: "bg-amber-500/10 text-amber-500",
        hoverColor: "group-hover:bg-amber-500 group-hover:text-white",
        link: import.meta.env.VITE_APP_BRAND_SITE_URL,
        alwaysAccessible: true,
        permissionModules: undefined,
        category: "other",
    },
];
